/* Nynorsk tekstar og kodeetikettar. */

export const STATUS_LABELS = { ny: "Ny", i_arbeid: "I arbeid", utfort: "Utført", avlyst: "Avlyst" };
export const STATUS_ORDER = ["i_arbeid", "ny", "utfort", "avlyst"];

export const BASIS_STATUS_LABELS = { kladd: "Kladd", godkjent: "Godkjent", erstatta: "Erstatta" };

export const INVOICE_STATUS_LABELS = {
  ingen: "Ikkje starta",
  kladd: "Kladd",
  godkjent: "Klar til fakturering",
  eksportert: "Eksportert",
  fakturert: "Fakturert",
};

export const TEMPLATES = [
  { value: "transport_og_kran", label: "Transport og kran" },
  { value: "levering_av_massar", label: "Levering av massar" },
  { value: "grunnarbeid_og_muring", label: "Grunnarbeid og muring" },
  { value: "container_og_avfall", label: "Container og avfall" },
  { value: "dekk_og_hydraulikk", label: "Dekk og hydraulikk" },
  { value: "minibuss", label: "Minibuss" },
  { value: "anna", label: "Anna" },
];
export const TEMPLATE_LABELS = Object.fromEntries(TEMPLATES.map((t) => [t.value, t.label]));

export const UNITS = [
  { value: "time", label: "time" },
  { value: "t", label: "tonn (t)" },
  { value: "m3", label: "m³" },
  { value: "stk", label: "stk" },
  { value: "m", label: "meter (m)" },
  { value: "lass", label: "lass" },
  { value: "km", label: "km" },
  { value: "dag", label: "dag" },
  { value: "kg", label: "kg" },
  { value: "l", label: "liter (l)" },
];
export const UNIT_LABELS = Object.fromEntries(UNITS.map((u) => [u.value, u.label]));
export const unitShort = (unit) => (unit === "m3" ? "m³" : unit || "");

export const ENTRY_TYPE_LABELS = { timar: "Timar", ressurs: "Køyretøy/maskin", vare: "Vare", merknad: "Merknad" };

export const RESOURCE_TYPE_LABELS = { koyretoy: "Køyretøy", maskin: "Maskin", utstyr: "Utstyr" };
export const CATALOG_CATEGORY_LABELS = { teneste: "Teneste (timar)", ressurs: "Køyretøy/maskin-sats", masse: "Masse", vare: "Vare" };
export const ROLE_LABELS = { administrasjon: "Administrasjon", medarbeidar: "Medarbeidar" };
export const LINE_KIND_LABELS = { timar: "Timar", ressurs: "Ressurs", vare: "Vare", fast: "Fastpris", tillegg: "Tillegg", manuell: "Manuell", rabatt: "Rabatt" };
export const EXPORT_STATUS_LABELS = { aktiv: "Aktiv", handtert: "Handtert" };
export const HANDLING_LABELS = { kreditert: "Kreditert i rekneskapen", ikkje_sendt: "Ikkje sendt vidare", trekt_tilbake: "Trekt tilbake", anna: "Anna (sjå merknad)" };

export const AUDIT_LABELS = {
  ordre_oppretta: "Ordre oppretta",
  ordre_endra: "Ordre endra",
  ordre_tildelt: "Ordre tildelt",
  status_i_arbeid: "Sett i arbeid",
  status_utfort: "Meld utført",
  status_avlyst: "Avlyst",
  status_gjenopna: "Gjenopna",
  registrering_oppretta: "Registrering lagt til",
  registrering_endra: "Registrering endra",
  registrering_sletta: "Registrering sletta",
  vedlegg_lasta_opp: "Vedlegg lasta opp",
  vedlegg_sletta: "Vedlegg sletta",
  fakturagrunnlag_oppretta: "Fakturagrunnlag (kladd) oppretta",
  fakturagrunnlag_endra: "Fakturagrunnlag endra",
  fakturagrunnlag_regenerert: "Fakturagrunnlag oppdatert frå registreringar",
  fakturagrunnlag_forkasta: "Kladd forkasta",
  fakturagrunnlag_godkjent: "Fakturagrunnlag godkjent (låst revisjon)",
  eksport_oppretta: "Eksport laga",
  eksport_handtert: "Eksport handtert",
  fakturert_manuelt: "Merkt fakturert",
  demo_tilbakestilt: "Eksempeldata lasta inn på nytt",
  kunde_oppretta: "Kunde oppretta",
  kunde_endra: "Kunde endra",
  ressurs_oppretta: "Ressurs oppretta",
  ressurs_endra: "Ressurs endra",
  katalog_oppretta: "Katalogvare oppretta",
  katalog_endra: "Katalogvare endra",
  katalog_importert: "Prisliste importert",
  katalog_sletta: "Katalogvare sletta",
  brukar_oppretta: "Brukar oppretta",
  brukar_endra: "Brukar endra",
  lokasjon_oppretta: "Lokasjon oppretta",
  lokasjon_endra: "Lokasjon endra",
};

export const LOCATION_TYPE_LABELS = { kunde: "Kunde", steinbrot: "Steinbrot/grustak", lager: "Lager/base", deponi: "Deponi", ferjekai: "Ferjekai", anna: "Anna" };
export const TRANSPORT_MODE_LABELS = { per_time: "Timesats for bilen", per_km: "Pris per km", per_lass: "Pris per lass", inkludert: "Inkludert i materialpris" };
export const ESTIMATE_KIND_LABELS = { materiale: "Masse", vare: "Vare", teneste: "Teneste", ressurs: "Køyretøy/maskin", transport: "Transport", ferje: "Ferje", bom: "Bom", tillegg: "Tillegg", rabatt: "Rabatt", intern: "Intern kostnad" };
export const CATALOG_CATEGORY_SHORT = { teneste: "Teneste", ressurs: "Køyretøy/maskin", masse: "Masse", vare: "Vare" };
export const PRICE_SOURCE_LABELS = { katalog: "Katalogpris", kundeavtale: "Kundeavtale", standard: "Standardsats", manuell: "Manuelt sett" };
export const CUSTOMER_TYPE_LABELS = { bedrift: "Bedrift", privat: "Privat", offentleg: "Offentleg/lag" };

export const NAV = {
  mineOrdrar: "Mine ordrar",
  ordrar: "Ordrar",
  planlegging: "Planlegging",
  tilKontroll: "Til kontroll",
  klarTilFakturering: "Klar til fakturering",
  register: "Register",
  omSystemet: "Om systemet",
  meir: "Meir",
};
